import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import useIsUSPlanholder from 'products/nomad_insurance/hooks/useIsUSPlanholder';
import useCreditToBeApplied from 'products/nomad_insurance/hooks/useCreditToBeApplied';
import CoveragePeriod from '../CoveragePeriod';
import ReferralFeedback from '../ReferralFeedback';
import CreditFeedback from '../CreditFeedback';
import Addons from '../Addons';
import { addonChange } from '../../state';
import { InsuranceProviderText, StyledButton, RecurringInfo } from './styled';
import { InfoText, NextRow } from '../../../../styled';
import VoucherFeedback from '../VoucherFeedback';

const MainContent = ({ minStartDate, onNextClick }) => {
  const dispatch = useDispatch();
  const { addons, numberOfDays, isLoading, hasEndDate } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const { plans } = useSelector((state) => state.nomadInsurance.application);
  const { isHomeCountryUS, isCitizenshipUS } = useIsUSPlanholder();

  const { creditToBeApplied } = useCreditToBeApplied();

  return (
    <>
      {creditToBeApplied && <CreditFeedback />}
      {/* For now, C2C and Reactivation gift cards are shown differently than other credits */}
      {!creditToBeApplied && <ReferralFeedback />}

      <VoucherFeedback />

      <CoveragePeriod plans={plans} minStartDate={minStartDate} />

      <Addons
        showUSAddon={!(isCitizenshipUS || isHomeCountryUS)} // TODO: Await confirmation on US addon logic for NI US residents
        numberOfDays={numberOfDays}
        selectedAddons={addons}
        onAddonChange={(addon) => dispatch(addonChange(addon))}
        isFixed={hasEndDate}
      />

      {!hasEndDate && (
        <RecurringInfo variant="info" topAlignIcon>
          You will be charged for your first payment today. After that, you'll be charged
          3 days before each 4-week period to avoid any gaps in coverage. You can stop
          your plan anytime through your dashboard.
        </RecurringInfo>
      )}

      <InsuranceProviderText>
        You are purchasing insurance through SafetyWing I.I.
      </InsuranceProviderText>

      <NextRow>
        <StyledButton color="confetti" disabled={isLoading} onClick={onNextClick}>
          Next
        </StyledButton>
        <InfoText>Next up, add your basic information</InfoText>
      </NextRow>
    </>
  );
};

MainContent.propTypes = {
  minStartDate: PropTypes.string,
  onNextClick: PropTypes.func.isRequired
};

export default MainContent;
